import React, { Suspense, lazy, useEffect } from "react";
import Layout from "./pages/layout";
import { Router, Switch, Route } from "react-router-dom";
//import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.less";
import createHistory from "./createHistory";
function App() {
  const LazyLogin = lazy(() => import("pages/loginPage")); // 登录页
  const LazyRegister = lazy(() => import("pages/loginPage/register")); // 注册
  const MiddleComponent = lazy(() => import("pages/middle/index"));
  const AuthorizationJump = lazy(() => import("pages/AuthorizationJump/index")); // 授权跳转中间页
  const ChangePassword = lazy(() => import("pages/loginPage/changePassword")); // 修改密码
  const ProductDetail = lazy(() => import("pages/unifyProducts/hotProducts/detail")); // 商品详情
  const ProductLabel = lazy(() => import("pages/unifyProducts/hotProducts/ProductLabel")); // 商品标签列表
  const errorPage = lazy(() => import("pages/errorPage")); // 错误页面

  // useEffect(() => {
  //   let beginTime = 0;
  //   let gapTime = 0;
  //   const listener = ev => {
  //     ev.preventDefault();
  //     gapTime = new Date().getTime() - beginTime;
  //     if (gapTime <= 5) { // 关闭窗口 
  //       window.localStorage.removeItem('authorization')
  //       window.localStorage.removeItem('useInfo')
  //     }
  //     else {
  //       console.info("你正在刷新页面");
  //     }
  //   }
  //   window.addEventListener('unload', listener);
  //   window.addEventListener('beforeunload', () => {
  //     beginTime = new Date().getTime();
  //   });
  //   return () => {
  //     window.localStorage.removeItem('authorization')
  //     window.localStorage.removeItem('useInfo')
  //     window.removeEventListener('unload', listener)
  //   }
  // }, []);

  return (
    <Router history={createHistory()}>
      <Suspense fallback={<div className="container">
        <div className="progress progress-striped">
          <div className="progress-bar">
          </div>
        </div>
      </div>}>
        <Switch>
          <Route exact path="/login" component={LazyLogin} />
          <Route exact path="/register" component={LazyRegister} />
          <Route exact path="/middle" component={MiddleComponent} />
          <Route exact path="/AuthorizationJump" component={AuthorizationJump} />
          <Route exact path="/ChangePassword" component={ChangePassword} />
          <Route exact path="/unifyDrop/unifyProducts/productDetail" component={ProductDetail} />
          <Route exact path="/unifyDrop/unifyProducts/ProductLabel" component={ProductLabel} />
          <Route exact path="/403" component={errorPage} />
          <Route>
            <Layout />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
